import { lang } from "../config/app.config"
import { httpbase } from "../utils/axios.utils"

export const fetchFormBySlug = async(slug:string) =>{
  try{
    const response = await httpbase().get(`form/contact-form?lang=${lang}`)
    return response.data.data;
  }catch(e){
    console.log(e);
  }
}

export const submitForm = async (formData:FormData)=>{
  try{
    const response = await httpbase().post(`form-response`,formData)
    return {success:true,message:response.data.message};
  }catch(e){
    console.log(e);
    return {success:false,message:"Something went wrong."};
  }
}